import {dreditionApiUrl} from '../config.ts';
import {isTokenExpired} from './jwt.ts';

const AUTH_TOKEN_KEY = 'jwtAuthToken';
const CLIENT_ID_KEY = 'clientId';
const RESOURCE_TYPE = 'resourceType';
const RESOURCE_ID = 'resourceId';
const PRODUCT_TYPE = 'productType';
const LOGIN_REDIRECT_KEY = 'loginRedirectTo';

export function getClientId(): string {
	const url = new URL(location.href);
	const clientIdFromQuery = url.searchParams.get('clientId');
	if (typeof clientIdFromQuery === 'string') {
		return clientIdFromQuery;
	}

	const hostParts = window.location.host.split('.');
	if (hostParts.length === 1 || hostParts.length === 3) {
		return getItem(CLIENT_ID_KEY);
	}

	return hostParts[0] || getItem(CLIENT_ID_KEY);
}

export function setClientId(value: string) {
	return setItem(CLIENT_ID_KEY, value);
}

export function clearClientId() {
	return removeItem(CLIENT_ID_KEY);
}

export function setAuthToken(value: string) {
	return setItem(AUTH_TOKEN_KEY, value);
}

export function getAuthToken() {
	return getItem(AUTH_TOKEN_KEY) as string;
}

export function clearAuthToken() {
	return removeItem(AUTH_TOKEN_KEY);
}

export function setLoginRedirectTo(url: string) {
	return setItem(LOGIN_REDIRECT_KEY, url);
}

export function getLoginRedirectTo() {
	return getItem(LOGIN_REDIRECT_KEY);
}

export function setLatestResourceType(value: string) {
	return setItem(RESOURCE_TYPE, value);
}

export function getLatestResourceType() {
	return getItem(RESOURCE_TYPE);
}

export function setLatestResourceId(value: string) {
	return setItem(RESOURCE_ID, value);
}

export function getLatestResourceId() {
	return getItem(RESOURCE_ID);
}

export function setLatestProductType(value: string) {
	return setItem(PRODUCT_TYPE, value);
}

export function getLatestProductType() {
	return getItem(PRODUCT_TYPE);
}

function getItem(key: string) {
	return localStorage.getItem(key) as string;
}

function setItem(key: string, value: string) {
	localStorage.setItem(key, value);
}

function removeItem(key: string) {
	localStorage.removeItem(key);
}

export async function refreshToken(token: string, onSessionExpire: () => void) {
	if (!token) {
		return;
	}

	// Autorenew JWT token 23 hours before it expires to avoid “Session timed out”.
	if (!isTokenExpired(token, 86400 - 3600)) {
		return;
	}

	const res = await fetch(`${dreditionApiUrl}/auth/refresh-token`, {
		headers: {
			Authorization: `Bearer ${token}`
		}
	});

	if (res.status === 200) {
		const {token} = await res.json();
		return token;
	}

	if (res.status === 401 && onSessionExpire) {
		onSessionExpire();
	}
}
